@if (message) {
  <mat-card>
    <mat-card-header>
      <mat-card-title>
        {{ message.senderName }}
      </mat-card-title>
      <mat-card-subtitle>
        {{ message.timeStamp | date : 'yyyy-MM-dd HH:mm' }}
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <mat-divider></mat-divider>
      <div class="content">
        {{ message.content }}
      </div>
    </mat-card-content>
    <mat-card-actions align="end">
      <button mat-stroked-button
              [routerLink]="['/', 'home' ]"
      >Tillbaka
      </button>
    </mat-card-actions>
  </mat-card>
} @else {
  <mat-progress-bar mode="buffer"></mat-progress-bar>
}